import { ThunkAction } from 'redux-thunk';
import { SET_CHART_LIST, SET_IS_IN_IFRAME, SET_COM_REFS, SET_CURR_IFRAME_URL, SET_ROUTES } from './constants';

export type ActionType = ReturnType<typeof setChartList | typeof setIsInIframe | typeof setComRefs | typeof setCurrIframeUrl | typeof setRoutes>;

type ThunkFunction = ThunkAction<void, any, null, ActionType>;

export const setChartList = (charts: any[]) => ({ type: SET_CHART_LIST, charts } as const);
export const setIsInIframe = (isInIframe: boolean) => ({ type: SET_IS_IN_IFRAME, isInIframe } as const);
export const setCurrIframeUrl = (iframeUrl: string) => ({ type: SET_CURR_IFRAME_URL, iframeUrl } as const);
export const setComRefs = (comRefs: Object) => ({ type: SET_COM_REFS, comRefs } as const);
export const setRoutes = (routes: any[]) => ({ type: SET_ROUTES, routes } as const);

export const setChartListAfterSearch =
  (charts: any[]): ThunkFunction =>
    async (dispatch: Function) => {
      dispatch(setChartList(charts));
    };

export const setComRefsAction =
  (comRefs: Object): ThunkFunction =>
    async (dispatch: Function) => {
      dispatch(setComRefs(comRefs));
    };

export const setCurrIframeUrlAction =
  (iframeUrl: string): ThunkFunction =>
    async (dispatch: Function) => {
      dispatch(setCurrIframeUrl(iframeUrl));
    };

export const setRoutesAction =
  (routes: any[]): ThunkFunction =>
    async (dispatch: Function) => {
      dispatch(setRoutes(routes));
    };
